<template>
  <div class="hello">
    <div style="height: 54px;"></div>
    <div class="head" style="background-color: #242E6C;">
      <div>
        <router-link to="/">
          <img class="logo" style="width: 110px;" src="../../../assets/images/crm/crmLogo1.png" alt=""
        /></router-link>
        <ul class="nav_left">
          <li
            @click="push_index"
            :style="{ marginLeft: '81px', color: '#fff' }"
          >
            <span>主页</span></span>
          </li>

          <li
            :style="{
              marginLeft: '81px',
              color: '#fff',
            }"
            @mouseenter="service = true"
            @mouseleave="service = false"
          >
            <span>排行</span
            ><img
              class="img1"
              src="../../../assets/images/bottom1.png"
              alt=""
            />
            <img
              class="img2"
              style="display: none;"
              src="../../../assets/images/shang.png"
              alt=""
            />
            <transition name="el-fade-in-linear">
              <ul v-show="service">
                <a @click="pushRankingM" href="javascript:;">本月排行</a>
                <a @click="pushRankingY" href="javascript:;">本年排行</a>
                <a @click="pushRankingJ" href="javascript:;">净值排行</a>
                <a @click="pushRankingH" href="javascript:;">回撤排行</a>

                <a
                  @click="pushRanking_M"
                  style="border-bottom: 0;"
                  href="javascript:;"
                  >最优合作方</a
                >
              </ul>
            </transition>
          </li>
        </ul>
        <ul class="nav_right">
          <div
            class="login"
            style="margin-left: 60px;font-size: 22px;line-height: 60px;cursor: pointer;"
            v-if="userstate"
            @click="login"
          >
            登录/注册
          </div>
          <!-- <li v-if=userstate @click=register>注册</li> -->

          <li
            class="li_img imgli"
            @click="pushNews"
            v-if="!userstate"
            :style="{
              width: '60px',
              height: '52px',
              marginLeft: '35px',

              textAlign: 'center',
            }"
          >
            <el-badge
              style="line-height: 60px;"
              :value="news ? news : ''"
              :max="99"
              class="item"
            >
              <i style="font-size: 20px;color: #fff;" class="el-icon-bell"></i>
            </el-badge>
          </li>

          <li
            class="li_img imgli"
            v-if="!userstate"
            @mouseenter="user = true"
            @mouseleave="user = false"
            :style="{
              width: '60px',
              height: '52px',
              marginLeft: '35px',
              marginRight: '70px',
            }"
          >
            <img
              src="../../../assets/images/headPic.png"
              alt=""
              style="width: 36px;height: 36px;margin: 9px auto 0;display: block;"
            />
            <transition name="el-fade-in-linear">
              <ul class="user" v-show="user">
                <a
                  style="border-bottom: 1px solid #EDF0F6;"
                  @click="push_account"
                  href="javascript:;"
                >
                  个人中心</a
                >
                <a @click="next">退出登录</a>
              </ul>
            </transition>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import './style.css';
export default {
  component: {},
  data() {
    return {
      userstate: localStorage.getItem('token') ? false : true,
      user: false,
      service: false,
      news: '',
    };
  },
  mounted() {
    this.$axios
      .post('/crm/queryUnReadMessage', {
        apiToken: this.$store.state.usermsg.apiToken,
      })
      .then((res) => {
        // console.log(res);
        this.news = res.data.data;
      });
  },
  methods: {
    login() {
      this.$router.push('/login?type=login');
    },
    next() {
      localStorage.removeItem('token');
      localStorage.removeItem('res');
      //   localStorage.removeItem('msg');

      this.$router.push('/');
    },
    push_account() {
      this.$router.push('/user/account/list');
    },
    push_index() {
      //  主页
      this.$router.push('/crm/index');
    },
    pushNews() {
      this.$router.push('/crm/news');
    },
    pushRankingM() {
      this.$router.push('/crm/Ranking?type=month');
    },
    pushRankingY() {
      this.$router.push('/crm/Ranking?type=year');
    },
    pushRankingJ() {
      this.$router.push('/crm/Ranking?type=netWorth');
    },
    pushRankingH() {
      this.$router.push('/crm/Ranking?type=hc');
    },

    pushRanking_M() {
      this.$router.push('/crm/Ranking?type=mechanism');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/header/index.vue